
import moment from 'moment'
import { mapState } from 'vuex'
import Icon from './Icon'

export default {
  name: 'EarliestAvailable',
  components: {
    Icon,
  },
  computed: {
    ...mapState(['appInfo', 'cart']),
    format() {
      return 'h:mm A'
    },
    time() {
      if (!this.cart?.time) {
        return null
      }
      return this.cart.time.mode === 'advance' ? this.cart.time.wanted : this.cart.time.earliest
    },
    show() {
      return this.appInfo['show_earliest'] && this.time && this.cart.products.length > 0
    },
    getTime() {
      if (!this.show) {
        return null
      }
      return moment(this.time, "YYYYMMDD HH:mm")
    },
    deliveryDay() {
      if (!this.show) {
        return false
      }
      const today = moment()
      const tomorrow = moment().add(1, 'day')
      const input = moment(this.time, "YYYYMMDD")
      if (input.isSame(today, 'day')) return "Today"
      if (input.isSame(tomorrow, 'day')) return "Tomorrow"
      return input.format("dddd")
    },
    earliestAvailable() {
      if (!this.show || !this.getTime) {
        return false
      }
      return this.getTime.format(this.format)
    },
    earliestAvailableMax() {
      if (!this.show || !this.appInfo['bump_earliest_minutes'] || !this.getTime) {
        return false
      }
      return this.getTime.add(this.appInfo['bump_earliest_minutes'], 'minutes').format(this.format)
    }
  }
}
